import { RouteObject, Outlet } from 'react-router-dom';
import HubPage from '../pages/hub/page';
import BeveragePage from '../pages/beverage/page';
import AirportPage from '../pages/airport/page';
import OperatorPage from '../pages/operator/page';
import TermsPage from '../pages/privacy/page';
import PrivacyPolicyPage from '../pages/privacy-policy/page';
import StartFreePage from '../pages/start-free/page';
import NotFoundPage from '../pages/NotFound';
import ScrollToTop from '../components/ScrollToTop';

// Eager imports (instead of React.lazy) so every route renders synchronously
// during the static pre-render (SSG) build. The site is small enough that
// per-route code-splitting is not worth the SSR/Suspense complexity.
const routes: RouteObject[] = [
  {
    // Pathless layout route: resets scroll to the top on every client-side
    // navigation (SPA keeps the old scroll otherwise), honoring URL hashes.
    element: (
      <>
        <ScrollToTop />
        <Outlet />
      </>
    ),
    children: [
      {
        // 2026 redesign: the Hub is the homepage. The three product pages and
        // the existing /start-free application live alongside it.
        path: '/',
        element: <HubPage />,
      },
      {
        path: '/beverage',
        element: <BeveragePage />,
      },
      {
        path: '/airport',
        element: <AirportPage />,
      },
      {
        path: '/operator',
        element: <OperatorPage />,
      },
      {
        path: '/terms',
        element: <TermsPage />,
      },
      {
        path: '/privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: '/start-free',
        element: <StartFreePage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];

export default routes;
